<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <stock-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import StockProvider from "../../../../providers/StockProvider";

    import {CrudUpdate, ClientError} from '@dracul/common-frontend'

    import StockForm from "../StockForm";



    export default {
        name: "StockUpdate",

        components: { StockForm, CrudUpdate },

        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'delivery.stock.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    branch: this.item.branch ? this.item.branch : null,
                    items: this.item.items ? this.item.items.map(i=> ({
                      product: i.product,
                      quantity: i.quantity,
                      order: i.order,
                      minimum: i.minimum,
                      hide: i.hide,

                    }) ) : null
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true

                    let input = {
                      branch: this.form.branch.id,
                      items: this.form.items.map(i => ({
                        product: i.product.id,
                        quantity: i.quantity,
                        order: i.order,
                        minimum: i.minimum,
                        hide: i.hide,
                      }))
                    }

                    StockProvider.updateStock(this.id, input).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateStock)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

